import { useEffect } from "react";
import { getSeoForPath, siteConfig } from "../data/seo.js";

function setMeta(selector, attr, value) {
  if (!value) return;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    if (selector.includes("property=")) {
      element.setAttribute("property", selector.match(/property="([^"]+)"/)?.[1] || "");
    } else {
      element.setAttribute("name", selector.match(/name="([^"]+)"/)?.[1] || "");
    }
    document.head.appendChild(element);
  }
  element.setAttribute(attr, value);
}

function setLink(rel, href) {
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export default function SEO({ path }) {
  useEffect(() => {
    const seo = getSeoForPath(path);
    document.title = seo.title;

    setMeta('meta[name="description"]', "content", seo.description);
    setMeta('meta[name="keywords"]', "content", seo.keywordsText);
    setMeta('meta[name="robots"]', "content", "index, follow");
    setMeta('meta[property="og:site_name"]', "content", siteConfig.name);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:title"]', "content", seo.title);
    setMeta('meta[property="og:description"]', "content", seo.description);
    setMeta('meta[property="og:url"]', "content", seo.canonical);
    setMeta('meta[property="og:image"]', "content", seo.imageUrl);
    setMeta('meta[property="og:locale"]', "content", siteConfig.locale);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", seo.title);
    setMeta('meta[name="twitter:description"]', "content", seo.description);
    setMeta('meta[name="twitter:image"]', "content", seo.imageUrl);
    setLink("canonical", seo.canonical);

    let schema = document.getElementById("schema-json");
    if (!schema) {
      schema = document.createElement("script");
      schema.type = "application/ld+json";
      schema.id = "schema-json";
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify(
      seo.schema || {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: seo.title,
        url: seo.canonical,
        description: seo.description,
        publisher: {
          "@type": "Organization",
          name: siteConfig.name
        }
      }
    );
  }, [path]);

  return null;
}
